import { useCitySearch } from './useCitySearch';
import { isValidDanishPostalCode, normalizeCitySearchQuery } from './utils';

export const useCityByPostCode = (postCode?: string) => {
    const normalizedPostCode = normalizeCitySearchQuery(postCode);
    const isValidPostCode = isValidDanishPostalCode(normalizedPostCode);

    const { data, isFetching, isSuccess } = useCitySearch(
        isValidPostCode ? normalizedPostCode : '',
    );

    const cityName = data?.find((entry) => entry.postCode === normalizedPostCode)?.cityName;

    return {
        cityName,
        isFetchingCityByPostCode: isValidPostCode && isFetching,
        hasNoMatchingPostCode: isValidPostCode && isSuccess && !cityName,
    };
};
